angular.module('aq.filters.units')
    .filter('toUnitWithLabel', ['$filter', function ($filter) {
        return function (input, unit, stripIntensity, showPlus) {
            if (unit == null) return;
            if (input == null) return '- ' + unit.unit;
            var converted = $filter('toUnit')(input, unit, true);
            return ((showPlus && converted > 0) ? '+' : '') + $filter('withLabel')(converted, unit, stripIntensity);
        }
    }]);
